const APK_CONTENT_TYPE = 'application/vnd.android.package-archive';

export async function downloadTotalNotifyApk(apiUrl, jwtToken) {
    const response = await fetch(apiUrl + 'apk/download/', {
        headers: { 'Authorization': `JWT ${jwtToken}` },
    });

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (!response.ok || !contentType.includes(APK_CONTENT_TYPE)) {
        throw new Error('TotalNotify APK is unavailable');
    }

    const blob = await response.blob();
    if (!blob.size) {
        throw new Error('TotalNotify APK is empty');
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'totalnotify.apk';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}
